var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"menu-container"},_vm._l((_vm.items),function(item){return _c('router-link',{key:item.link,attrs:{"exact":item.exact,"to":{name: item.name}}},[_c('div',{staticClass:"icon"},[_c('Icon',{attrs:{"type":item.icon}})],1),_c('span',[_vm._v(_vm._s(item.title))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }